import ShopItemDto, { ShopItemPayload } from '../models/dtos/ShopItemDto';

/** Full PATCH body expected by analytics shop product update. */
export function toShopItemPayload(item: ShopItemDto): ShopItemPayload {
    return {
        storeCode: item.storeCode ?? '',
        oldStoreCode: item.oldStoreCode,
        iconUrl: item.iconUrl,
        type: item.type,
        titleText: item.titleText,
        color: item.color,
        betcoins: item.betcoins,
        visualPrice: item.visualPrice ?? '0',
        effectId: item.effectId,
        noAds: item.noAds,
        openBets: item.openBets ?? false,
        interestFactor: item.interestFactor ?? 0,
        effectDuration: item.effectDuration,
        osType: item.osType,
        displaySection: item.displaySection ?? 'COIN_PACKS',
        displayOrder: item.displayOrder ?? 0,
        displayLabel: item.displayLabel,
        badgeType: item.badgeType,
        rewardType: item.rewardType ?? 'INSTANT_COINS',
        instantCoins: item.instantCoins ?? 0,
        dailyCoins: item.dailyCoins ?? 0,
        packageDays: item.packageDays,
        missedDayPolicy: item.missedDayPolicy ?? 'LOSE_DAY',
        offerExpiresAt: item.offerExpiresAt || undefined,
        requiresNoPriorPurchases: item.requiresNoPriorPurchases ?? false,
        presentationMode: item.presentationMode ?? 'HTML_INLINE',
        htmlContent: item.htmlContent || undefined,
        htmlTemplateUrl: item.htmlTemplateUrl || undefined,
        columnsInRow: item.columnsInRow ?? 1,
    };
}

export function isNewShopSku(item: Pick<ShopItemDto, 'storeCode'>): boolean {
    return (item.storeCode ?? '').startsWith('new_shop_');
}
